import { render, staticRenderFns } from "./massanumberuploadcomponent.vue?vue&type=template&id=5f22cbda&"
import script from "./massanumberuploadcomponent.vue?vue&type=script&lang=ts&"
export * from "./massanumberuploadcomponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports